import { render, staticRenderFns } from "./marketcontent.vue?vue&type=template&id=2a21546d&scoped=true"
import script from "./marketcontent.vue?vue&type=script&lang=js"
export * from "./marketcontent.vue?vue&type=script&lang=js"
import style0 from "./marketcontent.vue?vue&type=style&index=0&id=2a21546d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a21546d",
  null
  
)

export default component.exports